import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import { Router } from "@angular/router";
import { V } from "@angular/cdk/keycodes";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import Swal from "sweetalert2";
import { EditorModule, TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { environment } from "src/environments/environment";
import { Editor } from "ngx-editor";

@Component({
  selector: "app-idea",
  templateUrl: "./idea.component.html",
  styleUrls: ["./idea.component.css"],
})
export class IdeaComponent implements OnInit, OnDestroy {
  idea_id: any;
  idea_name: any;
  track_name: any;
  fake = "6";
  form: any;
  editor: Editor;
  stuff: any;
  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private router: Router
  ) {}
  // safeSrc1 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  // safeSrc2 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://youtu.be/HTJKD6PzvVE");
  // safeSrc3 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=wWpEiSKeDDo&t=2s");
  // safeSrc4 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=C91utiNU0cI");
  // safeSrc5 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=Y2-5aPewZCA");
  // safeSrc6 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=rlPVu0EzGAY");
  // safeSrc7 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  lit: any;
  list = [];
  link: any;
  listing: any;
  auth: any;
  ids: any;
  track: any;
  loaderDisplayStyle = "none";

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  ngOnInit(): void {
    this.editor = new Editor();
    // console.log(this.auth)
    this.ids = localStorage.getItem("formFilled");
    this.auth = localStorage.getItem("authToken");
    if (this.auth == null) {
      //isloggedin
      Swal.fire("Login to access dashboard");
      this.router.navigate(["/login"]);
    }
  }

  onSubmit() {
    Swal.fire("Submitted Successfully");
    this.router.navigateByUrl("/db");
  }

  changeLoaderDisplayState(event: boolean) {
    if (event) {
      this.loaderDisplayStyle = "block";
    } else {
      this.loaderDisplayStyle = "none";
    }
  }
}
